import { render } from "./Item3.vue?vue&type=template&id=062958d8"
import script from "./Item3.vue?vue&type=script&lang=ts"
export * from "./Item3.vue?vue&type=script&lang=ts"
script.render = render

export default script